/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from Options.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace Options.
 * @public
 */

goog.module('Options.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias1 = Soy.getTemplate('FieldBase.incrementaldom', 'render');

var $templateAlias2 = Soy.getTemplate('KeyValue.incrementaldom', 'render');


/**
 * @param {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleOptionDeleted: (*|null|undefined),
 *  _handleOptionFocused: (*|null|undefined),
 *  _handleOptionLabelEdited: (*|null|undefined),
 *  _handleOptionValueBlurred: (*|null|undefined),
 *  defaultLanguageId: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  displayErrors: (boolean|null|undefined),
 *  editingLanguageId: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<{disabled: boolean, generateKeyword: boolean, label: (!goog.soy.data.SanitizedContent|string), value: (!goog.soy.data.SanitizedContent|string)}>|null|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  readOnly: (boolean|null|undefined),
 *  repeatable: (boolean|null|undefined),
 *  required: (boolean|null|undefined),
 *  showLabel: (boolean|null|undefined),
 *  tip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  visible: (boolean|null|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var name = soy.asserts.assertType(goog.isString(opt_data.name) || opt_data.name instanceof goog.soy.data.SanitizedContent, 'name', opt_data.name, '!goog.soy.data.SanitizedContent|string');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleOptionDeleted = opt_data._handleOptionDeleted;
  /** @type {*|null|undefined} */
  var _handleOptionFocused = opt_data._handleOptionFocused;
  /** @type {*|null|undefined} */
  var _handleOptionLabelEdited = opt_data._handleOptionLabelEdited;
  /** @type {*|null|undefined} */
  var _handleOptionValueBlurred = opt_data._handleOptionValueBlurred;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var defaultLanguageId = soy.asserts.assertType(opt_data.defaultLanguageId == null || (goog.isString(opt_data.defaultLanguageId) || opt_data.defaultLanguageId instanceof goog.soy.data.SanitizedContent), 'defaultLanguageId', opt_data.defaultLanguageId, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var displayErrors = soy.asserts.assertType(opt_data.displayErrors == null || (goog.isBoolean(opt_data.displayErrors) || opt_data.displayErrors === 1 || opt_data.displayErrors === 0), 'displayErrors', opt_data.displayErrors, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var editingLanguageId = soy.asserts.assertType(opt_data.editingLanguageId == null || (goog.isString(opt_data.editingLanguageId) || opt_data.editingLanguageId instanceof goog.soy.data.SanitizedContent), 'editingLanguageId', opt_data.editingLanguageId, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<{disabled: boolean, generateKeyword: boolean, label: (!goog.soy.data.SanitizedContent|string), value: (!goog.soy.data.SanitizedContent|string)}>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<{disabled: boolean, generateKeyword: boolean, label: (!goog.soy.data.SanitizedContent|string), value: (!goog.soy.data.SanitizedContent|string)}>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var label = soy.asserts.assertType(opt_data.label == null || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var placeholder = soy.asserts.assertType(opt_data.placeholder == null || (goog.isString(opt_data.placeholder) || opt_data.placeholder instanceof goog.soy.data.SanitizedContent), 'placeholder', opt_data.placeholder, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var readOnly = soy.asserts.assertType(opt_data.readOnly == null || (goog.isBoolean(opt_data.readOnly) || opt_data.readOnly === 1 || opt_data.readOnly === 0), 'readOnly', opt_data.readOnly, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var repeatable = soy.asserts.assertType(opt_data.repeatable == null || (goog.isBoolean(opt_data.repeatable) || opt_data.repeatable === 1 || opt_data.repeatable === 0), 'repeatable', opt_data.repeatable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var required = soy.asserts.assertType(opt_data.required == null || (goog.isBoolean(opt_data.required) || opt_data.required === 1 || opt_data.required === 0), 'required', opt_data.required, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showLabel = soy.asserts.assertType(opt_data.showLabel == null || (goog.isBoolean(opt_data.showLabel) || opt_data.showLabel === 1 || opt_data.showLabel === 0), 'showLabel', opt_data.showLabel, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var tip = soy.asserts.assertType(opt_data.tip == null || (goog.isString(opt_data.tip) || opt_data.tip instanceof goog.soy.data.SanitizedContent), 'tip', opt_data.tip, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var visible = soy.asserts.assertType(opt_data.visible == null || (goog.isBoolean(opt_data.visible) || opt_data.visible === 1 || opt_data.visible === 0), 'visible', opt_data.visible, 'boolean|null|undefined');
  var param2903 = function() {
    if (items) {
      incrementalDom.elementOpenStart('div');
          incrementalDom.attr('class', 'ddm-field-options-container');
      incrementalDom.elementOpenEnd();
        var option2945List = items;
        var option2945ListLen = option2945List.length;
        for (var option2945Index = 0; option2945Index < option2945ListLen; option2945Index++) {
            var option2945Data = option2945List[option2945Index];
            incrementalDom.elementOpenStart('div', 'target_' + option2945Index);
                incrementalDom.attr('class', 'ddm-options-target');
                incrementalDom.attr('data-index', option2945Index);
                incrementalDom.attr('key', 'target_' + option2945Index);
            incrementalDom.elementOpenEnd();
            incrementalDom.elementClose('div');
            incrementalDom.elementOpenStart('div', option2945Index);
                incrementalDom.attr('class', 'ddm-field-options');
                incrementalDom.attr('data-index', option2945Index);
                incrementalDom.attr('key', option2945Index);
            incrementalDom.elementOpenEnd();
              incrementalDom.elementOpenStart('span');
                  incrementalDom.attr('class', 'ddm-options-drag ' + (readOnly ? 'disabled' : ''));
              incrementalDom.elementOpenEnd();
                incrementalDom.elementOpenStart('svg');
                    incrementalDom.attr('aria-hidden', 'true');
                    incrementalDom.attr('class', 'lexicon-icon lexicon-icon-drag');
                incrementalDom.elementOpenEnd();
                  incrementalDom.elementOpenStart('use');
                      incrementalDom.attr('xlink:href', spritemap + '#drag');
                  incrementalDom.elementOpenEnd();
                  incrementalDom.elementClose('use');
                incrementalDom.elementClose('svg');
              incrementalDom.elementClose('span');
              incrementalDom.elementOpenStart('div');
                  incrementalDom.attr('class', 'ddm-option-entry');
              incrementalDom.elementOpenEnd();
                $templateAlias2({events: {fieldEdited: _handleOptionLabelEdited, fieldFocused: _handleOptionFocused, fieldKeywordBlurred: _handleOptionValueBlurred}, generateKeyword: false, key: 'option' + option2945Index, keyword: option2945Data.value, keywordReadOnly: defaultLanguageId != editingLanguageId, index: option2945Index, name: 'option' + option2945Index, placeholder: placeholder, readOnly: option2945Data.disabled, ref: 'option' + option2945Index, required: required, showLabel: false, spritemap: spritemap, value: option2945Data.label}, null, opt_ijData);
                if (!(option2945Index == option2945ListLen - 1) && !readOnly) {
                  incrementalDom.elementOpenStart('button');
                      incrementalDom.attr('class', 'close close-modal');
                      incrementalDom.attr('data-onclick', _handleOptionDeleted);
                      incrementalDom.attr('type', 'button');
                  incrementalDom.elementOpenEnd();
                    incrementalDom.elementOpenStart('svg');
                        incrementalDom.attr('aria-hidden', 'true');
                        incrementalDom.attr('class', 'lexicon-icon lexicon-icon-times');
                    incrementalDom.elementOpenEnd();
                      incrementalDom.elementOpenStart('use');
                          incrementalDom.attr('xlink:href', spritemap + '#times');
                      incrementalDom.elementOpenEnd();
                      incrementalDom.elementClose('use');
                    incrementalDom.elementClose('svg');
                  incrementalDom.elementClose('button');
                }
              incrementalDom.elementClose('div');
            incrementalDom.elementClose('div');
          }
      incrementalDom.elementClose('div');
    }
  };
  $templateAlias1({contentRenderer: param2903, displayErrors: displayErrors, id: id, label: label, name: name, repeatable: repeatable, showLabel: showLabel, spritemap: spritemap, tip: tip, visible: visible}, null, opt_ijData);
}
exports.render = $render;
/**
 * @typedef {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleOptionDeleted: (*|null|undefined),
 *  _handleOptionFocused: (*|null|undefined),
 *  _handleOptionLabelEdited: (*|null|undefined),
 *  _handleOptionValueBlurred: (*|null|undefined),
 *  defaultLanguageId: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  displayErrors: (boolean|null|undefined),
 *  editingLanguageId: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<{disabled: boolean, generateKeyword: boolean, label: (!goog.soy.data.SanitizedContent|string), value: (!goog.soy.data.SanitizedContent|string)}>|null|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  readOnly: (boolean|null|undefined),
 *  repeatable: (boolean|null|undefined),
 *  required: (boolean|null|undefined),
 *  showLabel: (boolean|null|undefined),
 *  tip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  visible: (boolean|null|undefined)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'Options.render';
}

exports.render.params = ["name","spritemap","_handleOptionDeleted","_handleOptionFocused","_handleOptionLabelEdited","_handleOptionValueBlurred","defaultLanguageId","displayErrors","editingLanguageId","id","items","label","placeholder","readOnly","repeatable","required","showLabel","tip","visible"];
exports.render.types = {"name":"string","spritemap":"string","_handleOptionDeleted":"any","_handleOptionFocused":"any","_handleOptionLabelEdited":"any","_handleOptionValueBlurred":"any","defaultLanguageId":"string","displayErrors":"bool","editingLanguageId":"string","id":"string","items":"list<[\n\t\tdisabled: bool,\n\t\tgenerateKeyword: bool,\n\t\tlabel: string,\n\t\tvalue: string\n\t]>","label":"string","placeholder":"string","readOnly":"bool","repeatable":"bool","required":"bool","showLabel":"bool","tip":"string","visible":"bool"};
templates = exports;
return exports;

});

class Options extends Component {}
Soy.register(Options, templates);
export { Options, templates };
export default templates;
/* jshint ignore:end */
